import urljoin from 'url-join';
import { portalApi } from './index.api';

const MANIFEST = "manifest";

export const manifestApi = portalApi.injectEndpoints({
	endpoints: (builder) => ({
		webhook: builder.query({
			query: () => ({
				url: urljoin(MANIFEST, "file", "oneschema", "importwebhook"),
				// baseQueryWithAuth handles authorization header automatically
				method: 'POST',
			})
		}),
		token: builder.mutation({
			query: ({ ...params }) => ({
				url: urljoin(MANIFEST, "oneschema", "token"),
				// baseQueryWithAuth handles authorization header automatically
				method: 'GET',
				params,
				invalidatesTags: ['manifests'],
				responseHandler: (response) => response.text(),
			})
		}),
		download: builder.mutation({
			query: ({ projectId, manifestFileId, fileName }) => ({
				url: urljoin(MANIFEST, "file", "download", projectId, manifestFileId, `?fileName=${fileName}`),
				//url: `file/download/${projectId}/${manifestFileId}/?fileName=${fileName}`,
				// baseQueryWithAuth handles authorization header automatically
				method: 'GET'
			})
		}),
		downloadTemplate: builder.mutation({
			query: ({ projectId }) => ({
				url: urljoin(MANIFEST, "file", "download", projectId),
				// baseQueryWithAuth handles authorization header automatically
				method: 'GET'
			})
		}),
		list: builder.query({
			query: ({ projectId }) => ({
				url: urljoin(MANIFEST, "file", "list", projectId),
				// baseQueryWithAuth handles authorization header automatically
				method: 'GET'
			}),
			providesTags: ['manifests']
		}),
		upload: builder.mutation({
			query: (body) => ({
				url: urljoin(MANIFEST, "file", "upload"),
				// baseQueryWithAuth handles authorization header automatically
				method: 'POST',
				body
			}),
			invalidatesTags: ['manifests']
		}),
		update: builder.mutation({
			query: ({ projectId, ...body }) => ({
				url: urljoin(MANIFEST, "file", "modify", projectId),
				// baseQueryWithAuth handles authorization header automatically
				method: 'PUT',
				body
			}),
			invalidatesTags: ['manifests']
		}),
		delete: builder.mutation({
			query: ({ projectId, ...body }) => ({
				url: urljoin(MANIFEST, "file", "delete", projectId),
				// baseQueryWithAuth handles authorization header automatically
				method: 'POST',
				body
			}),
			invalidatesTags: ['manifests']
		}),
	}),
});

export const {
	useWebhookQuery,
	useTokenMutation,
	useDownloadMutation,
	useDownloadTemplateMutation,
	useListQuery,
	useUploadMutation,
	useUpdateMutation,
	useDeleteMutation
} = manifestApi;

/* 
POST /api/v1/manifest/file/oneschema/importwebhook
POST /api/v1/manifest/file/upload
GET /api/v1/manifest/file/download/{projectId}/{manifestFileId}
GET /api/v1/manifest/file/download/{projectId}
GET /api/v1/manifest/file/list/{projectId}
PUT /api/v1/manifest/file/modify/{projectId}
POST /api/v1/manifest/file/delete/{projectId}
GET /api/v1/manifest/oneschema/token
 */